import { NSLog } from '@/helpers/log';
const log = NSLog('helper/storage');

function save(key: any, data?: any) {
  key = `v1_${key}`.toLowerCase();
  try {
    if (data) {
      localStorage.setItem(key, JSON.stringify(data));
    } else { localStorage.setItem(key, ''); }
  } catch (err) {
    log('could not store', key, data);
  }
}

function load(key: any, defaultValue?: any) {
  key = `v1_${key}`.toLowerCase();
  try {
    const v = localStorage.getItem(key);
    if (v) {
      const ob = JSON.parse(v);
      return ob;
    }
  } catch (err) {
    log('could not load', key);
  }
  if (typeof defaultValue === 'function') {
    return defaultValue();
  }
  return defaultValue;
}

function clear() {
  try {
    localStorage.clear();
  } catch (err) {
    log('could not clear storage');
  }
}

export default {
  save,
  load,
  clear,
};

export {
  save,
  load,
  clear,
};
